<div class='row landing-container'>
  <div class='small-11 small-centered medium-8 large-7 columns callout availability no-background no-bottom'>
    <div class='row small-centered medium-margin columns interest-buttons button-bar'>
      <button class='button expand primary interested' (click)="goToInterested()">{{'gather.apply' | translate}}</button>
      <a class='no-thanks' width='144'(click)="goToNotInterested()" >{{'gather.not-a-fit' | translate}}</a>
    </div>
  </div>
  <div class='small-11 small-centered medium-8 large-7 columns callout availability body-space'>
    <div class='row medium-margin'>
      <div class='small-11 small-centered columns'>
        <h5 *ngIf='jobPosting' class='upper'>{{jobPosting.jobTitle}}</h5>
        <div class='subheader jobtype'>
          <span *ngIf='jobPosting && jobPosting.hourId === 1'>{{'gather.full-time' | translate}}&bull;</span>
          <span *ngIf='jobPosting && jobPosting.hourId === 2'>{{'gather.part-time' | translate}}&bull;</span>
          <span>{{placementType}} </span>

          <span *ngIf='jobPosting && jobPosting.duration'>({{jobPosting.duration}})</span>
          <div class='referenceInfo' >
            <div *ngIf='jobPosting && jobPosting.clientServiceManagerName'><span>{{'gather.agent' | translate}}</span>{{jobPosting.clientServiceManagerName}}</div>
            <span *ngIf='jobPosting'>{{'gather.jobId' | translate}}</span><span *ngIf='jobPosting'>{{jobPosting.jobPostingId}}</span>
            <span>{{jobPosting.externalJobPostingId || jobPosting.jobPostingId}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class='row medium-margin'>
      <div class='small-11 small-centered columns posting-info-container'>
        <div *ngIf='jobPosting && jobPosting.shareClientName' class="row">
          <div class="columns">
            <i class="material-icons medium posting-icon">business</i>
            <div class="text">{{jobPosting.clientName}}</div>
          </div>
        </div>
        <div *ngIf='jobPosting && jobPosting.jobLocation' class='row'>
          <div class='columns'>
            <i class='material-icons medium posting-icon'>room</i>
            <div class='text'>{{jobPosting.jobLocation}}</div>
          </div>
        </div>
        <div class="row">
          <div class="columns">
            <i class='material-icons medium posting-icon'>attach_money</i>
            <div class="text">
              {{jobPosting.minPay | currency:'USD':'symbol':'1.2-2'}}
              <span *ngIf='jobPosting.minPay != jobPosting.maxPay'>
                - {{jobPosting.maxPay | currency:'USD':'symbol':'1.2-2'}}</span>/{{payFrequencyWord}}
            </div>
          </div>
        </div>
<!--    jobPosting.salary is actually `Pay Comments` now but we never updated the db column name    -->
        <div *ngIf='jobPosting && jobPosting.salary && jobPosting.salary !==" "' class='row'>
          <div class='columns'>
            <img class="posting-icon non-material-icon" src="assets/icons/growing_money.png" alt="Pay comments icon" />
            <div class='text'>{{jobPosting.salary}}</div>
          </div>
        </div>
        <div *ngIf='jobPosting && jobPosting.startDate && jobPosting.startDate !==" " && hideForJapanOrder' class='row'>
          <div class='columns'>
            <i class='material-icons medium posting-icon'>event</i>
            <span>{{'gather.starting' | translate}}&nbsp;</span>
            <span>{{jobPosting.startDate}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class='xlarge-margin posting-desc-container'>
      <div class='row medium-margin' *ngIf='jobPosting && jobPosting.jobDescription'>
        <div class='small-11 small-centered columns'>
          <div class='text header description-header'>{{'gather.description' | translate}}</div>
          <div class='body posting-text' [innerHTML]='jobPosting.jobDescription'></div>
        </div>
      </div>
      <div class='row medium-margin' *ngIf='jobPosting && jobPosting.clientDescription'>
        <div class='small-11 small-centered columns posting-desc-container'>
          <div class='text header'>{{'gather.client-description' | translate}}</div>
          <div class='body posting-text' [innerHTML]='jobPosting.clientDescription'></div>
        </div>
      </div>
      <div class='row medium-margin' *ngIf='jobPosting && jobPosting.otherReqs'>
        <div class='small-11 small-centered columns posting-desc-container'>
          <div class='text header'>{{'gather.other-requirements' | translate}}</div>
          <div class='body posting-text' [innerHTML]='jobPosting.otherReqs'></div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf='fromTextMessage' class='small-11 small-centered medium-8 large-7 columns callout no-background gather-footer'>
    <div class='row small-centered medium-margin columns'>
      <p class='footer-text'>{{'gather.footer-address' | translate}}</p>
      <p class='footer-text privacy-policy'>{{'gather.privacy-policy' | translate}}</p>
    </div>
  </div>
</div>
